import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const loading = useSelector(state => state.auth.loading);
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[ProtectedRoute] state', {
        path: location.pathname,
        loading,
        isAuthenticated
      });
    }
  }, [loading, isAuthenticated, location.pathname]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[100dvh]">
        <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full border-green-500 border-t-transparent" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[ProtectedRoute] redirecting to /login', { from: location.pathname });
    }
    // Redirect to login and save the location they were trying to access
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  return children;
};

export default ProtectedRoute; 